export default "__VITE_ASSET__3d8e700a__"